import React, { useContext, useState } from 'react';
import { H6, Image } from '../../../AbstractElements';
import fireImage from '../../../assets/images/giftools.gif';
import Slider from 'react-slick';
import { announcementSliderOption } from './AnnouncementSliderOption';
import AnnouncementContext from '../../../_helper/Announcement';
import AnnouncementDetailModal from './AnnouncementDetailModal';

const AnnouncementSlider = () => {
  const { allAnnouncements, loading } = useContext(AnnouncementContext);

  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedAnnouncementDetail, setSelectedAnnouncementDetail] = useState(null);

  const activeAnnouncements = allAnnouncements.filter(ann => ann.isActive === true);

  const toggleDetailModal = () => {
    setIsDetailModalOpen(!isDetailModalOpen);
    if (isDetailModalOpen) {
      setSelectedAnnouncementDetail(null);
    }
  };

  const handleAnnouncementClick = (announcement) => {
    setSelectedAnnouncementDetail(announcement);
    setIsDetailModalOpen(true);
  };

  return (
    <>
      <div className='announcement-slider overflow-hidden '>
        {loading ? (
          <div className='d-flex h-100 align-items-center'>
            <H6 attrH6={{ className: 'mb-0 f-w-400 text-muted' }}>
              <span className='f-light'>Duyurular yükleniyor...</span>
            </H6>
          </div>
        ) : activeAnnouncements.length > 0 ? (
          <Slider className='m-0' {...announcementSliderOption}>
            {activeAnnouncements.map((announcement) => {
              const truncatedTitle = announcement.title.length > 60 ? announcement.title.substring(0, 60) + '...' : announcement.title;
              return (
                <div
                  className='d-flex h-100 align-items-center announcement-item'
                  key={announcement.id}
                  onClick={() => handleAnnouncementClick(announcement)}
                  style={{ cursor: 'pointer' }}
                  role="button"
                  tabIndex={0}
                  onKeyPress={(e) => e.key === 'Enter' && handleAnnouncementClick(announcement)}
                  title={`${announcement.title}: ${announcement.desc}`}
                >
                  <Image attrImage={{ src: fireImage, alt: 'gif', className: 'announcement-icon' }} />
                  <H6 attrH6={{ className: 'mb-0 f-w-400 announcement-text' }}>
                    <span className='font-primary me-1'>{truncatedTitle}</span>
                  </H6>
                </div>
              );
            })}
          </Slider>
        ) : (
          <div className='d-flex h-100 align-items-center'>
            <H6 attrH6={{ className: 'mb-0 f-w-400' }}>
              <span className='f-light'>Aktif duyuru bulunmamaktadır.</span>
            </H6>
          </div>
        )}
      </div>

      <AnnouncementDetailModal
        isOpen={isDetailModalOpen}
        toggle={toggleDetailModal}
        announcement={selectedAnnouncementDetail}
      />
    </>
  );
};

export default AnnouncementSlider;
